<template>
  <div class="mx-auto max-w-content w-full">
    <slot></slot>
  </div>
</template>
